var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-icon",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7194725,1.40029344 C4.66863418,0.800622372 6.46706404,0.5 8.11737729,0.5 C9.76904074,0.5 11.5329668,0.801104981 13.4061403,1.40029344 C13.9813038,1.58025627 14.5958705,2.05121333 14.607821,2.70170301 C14.7015983,7.80669649 14.4309909,10.2777008 13.6452736,11.543159 C12.6175248,13.1984274 9.81066595,15.2114321 8.40169942,15.4467806 C8.31078758,15.4821347 8.21502497,15.5 8.11737729,15.5 C8.07768029,15.4996287 8.07768029,15.4996287 8.08753996,15.4978636 C8.04793251,15.4996287 8.04793251,15.4996287 8.0082355,15.5 C7.91058783,15.5 7.81482522,15.4821347 7.81358965,15.4717376 C6.31494685,15.2114321 3.50808797,13.1984274 2.48033923,11.543159 C1.69462193,10.2777008 1.42401448,7.80669649 1.51779177,2.7017021 C1.52974232,2.05121333 2.14430895,1.58025627 2.7194725,1.40029344 Z M2.45513362,2.71892171 C2.36485232,7.63360282 2.62363881,9.99666608 3.27680341,11.0486379 C4.16207961,12.4744433 6.71339208,14.3096602 8.03617862,14.5678483 L8.03627892,14.5651978 C8.02687686,14.5634151 8.0174041,14.5625 8.0082355,14.5625 L8.08753996,14.5616695 L8.11737729,14.5625 C8.09910754,14.5625 8.07963012,14.5661337 8.15158702,14.5480675 C9.3765169,14.3353043 11.9573529,12.4843972 12.8488094,11.0486379 C13.501974,9.99666608 13.7607605,7.63360282 13.6704792,2.71892262 C13.6684389,2.60786347 13.3526704,2.36588255 13.1233526,2.29412146 C11.3358055,1.72233252 9.66720638,1.4375 8.11737729,1.4375 C6.56649517,1.4375 4.85999549,1.72270582 2.99835457,2.29535341 C2.77195184,2.36664194 2.45717074,2.60803781 2.45513362,2.71892171 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon16/core/check-small"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "11.5218669 4.94138313 12.3414206 5.7052482 7.22265989 10.9413831 3.94142061 7.71663682 4.74515689 6.93691239 7.20641205 9.35579222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.378c9352b8c6dd0e1750ffb89fbfe6c4.svg";
export { ForwardRef as ReactComponent };